import { Exception } from '@diziner/Exceptions/Exception';
export class InvalidArgumentException extends Exception {
}
